import { Accordion } from '../../../../../components/general/accordion';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrResponseMediumProps } from './props';
import { usePqrResponseMedium } from './hook';

export const PqrResponseMedium = ({
    responseMedium,
}: PqrResponseMediumProps) => {
    const { formik } = usePqrResponseMedium(responseMedium);

    return (
        <Accordion
            title="MEDIO DE RESPUESTA"
            icon={<PermPhoneMsgIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Medio de respuesta"
                        name="responseMedium"
                        size="small"
                        value={formik.values.responseMedium}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FieldText
                        label="Observación medio de respuesta"
                        name="observation"
                        size="small"
                        rows={2}
                        value={formik.values.observation}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
